import React, { useState } from 'react';
import {
  Avatar,
  ButtonBase,
  Card,
  CardContent,
  Chip,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';

import { useAppSelector } from '../../../../hooks';
import { TP_COLORS } from '../../../../constants';
import { ISection } from '../../../../store/V2/SectionSlice';
import { getCoursesState } from '../../../../store/V2/CoursesSlice';
import { getAuthState } from '../../../../store/AuthSlice';
import ViewHomeworkModal from '../modals/ViewHomeworkModal';

interface HomeworkSectionItemProps {
  orderNumber: number;
  section: ISection;
  isCourseSubscribed?: boolean;
}

const buttonStyles: SxProps = {
  backgroundColor: '#3498DB',
  color: TP_COLORS.white,
  p: '8px',
  borderRadius: '5px',
  fontSize: '12px',
  fontWeight: 600,
};

const containerStyles: SxProps = {
  backgroundColor: 'transparent',
  borderRadius: '10px',
  border: '1px dashed #CBD5E1',
};

const HomeworkSectionItem: React.FC<HomeworkSectionItemProps> = ({
  orderNumber,
  section,
  isCourseSubscribed = false,
}) => {
  // Store
  const { userCourse } = useAppSelector(getCoursesState);
  const { user } = useAppSelector(getAuthState);

  // State
  const [isViewHomeworkModalOpen, setViewHomeworkModalOpen] = useState(false);

  const isCourseTutor = userCourse?.tutors?.some(
    (tutor) => tutor?.tutor?._id === user?._id
  );

  return (
    <Card elevation={0} sx={containerStyles}>
      <CardContent sx={{ p: '16px' }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" flexGrow={1} mr="15px">
            <Avatar
              sx={{
                width: '36px',
                height: '36px',
                backgroundColor: isCourseSubscribed ? '#CBD5E1' : '#1C9FF7',
                color: '#F8FAFC',
                mr: '15px',
              }}
            >
              {orderNumber}
            </Avatar>
            <Stack gap={1}>
              <Chip
                size="small"
                label="Homework"
                color="info"
                sx={{ width: 'fit-content' }}
              />
              <Typography
                variant="subtitle2"
                fontWeight={600}
                className="ellipsis-text one-line"
              >
                {section.title}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center">
            {(isCourseTutor || isCourseSubscribed) && (
              <ButtonBase
                onClick={() => setViewHomeworkModalOpen(true)}
                sx={buttonStyles}
              >
                Homework
              </ButtonBase>
            )}
          </Stack>
        </Stack>
      </CardContent>
      {/* Modals */}
      {isViewHomeworkModalOpen && (
        <ViewHomeworkModal
          open={isViewHomeworkModalOpen}
          onClose={() => setViewHomeworkModalOpen(false)}
          section={section}
        />
      )}
    </Card>
  );
};

export default HomeworkSectionItem;
